module.exports = __webpack_public_path__ + "static/media/EMSD_HQ.0f7d8b86.jpg";